

























































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { DocumentFile } from '@/types/document'
import { ExStore } from 'vuex'
import { getEnvVar } from '@/utils'
import { EventEmitter } from 'events'
import { DeleteConfirmResults } from '@/constants/utils'
import { Patient } from '@/types/user'
import { isCordovaEnvironment } from '@/utils/cordova'
import { isCapacitorEnvironment } from '@/utils/capacitor'

enum EventTypes {
  CONFIRM_DELETE
}

const numberFormatter = (n: number) => {
  //
  if (n >= 100) {
    return n.toFixed(0)
  }
  return n.toFixed(1)
}

const fileSizeFormatter = (
  size?: number,
  unit: 'B' | 'KB' | 'MB' | 'GB' | 'TB' = 'B'
): string => {
  // KBで入ってくる想定
  if (!size) {
    return '-'
  }
  if (size < 1024) {
    return `${numberFormatter(size)} ${unit}`
  }
  if (unit == 'B') return fileSizeFormatter(size / 1024, 'KB')
  if (unit == 'KB') return fileSizeFormatter(size / 1024, 'MB')
  if (unit == 'MB') return fileSizeFormatter(size / 1024, 'GB')
  if (unit == 'GB') return fileSizeFormatter(size / 1024, 'TB')
  return `${numberFormatter(size)} TB`
}

@Component({
  filters: {
    fileSize: fileSizeFormatter,
    formatDate(dateString: string) {
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  },
  components: {
    DeleteConfirmModal: () =>
      import('@/components/common/modals/AlertModal.vue')
  }
})
export default class DocumentIndex extends Vue {
  $store!: ExStore
  files = [] as DocumentFile[]
  maxfiles = 0
  perPage = 1

  showDeleteConfirmModal = false
  events = new EventEmitter()

  patient: Patient | null = null

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientName() {
    if (!this.patient) return ''
    return `${this.patient.lastName}${this.patient.firstName}`
  }

  get maxPage() {
    return Math.ceil(this.maxfiles / this.perPage)
  }

  get pageNation() {
    return Number(this.$route.query.page || '1')
  }

  @Watch('pageNation')
  pageChange() {
    this.fetchFiles()
  }

  get pagePrev() {
    if (this.pageNation === 1) {
      return 1
    }
    return this.pageNation - 1
  }

  get pageNext() {
    if (this.pageNation === this.maxPage) {
      return this.maxPage
    }
    return this.pageNation + 1
  }
  get patientId() {
    return Number(this.$route.params.patientId)
  }

  async fetchPatient() {
    this.patient = await this.$api.user.patient({ patientId: this.patientId })
  }

  handleDeleteConfirmOk() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.OK)
  }

  handleDeleteConfirmCancel() {
    this.events.emit(EventTypes.CONFIRM_DELETE, DeleteConfirmResults.CANCEL)
  }

  async handleDownload(documentId: number) {
    const file = this.files.find(file => file.id === documentId)
    if (!file) throw new Error('does not exist file')
    if (isCordovaEnvironment() || isCapacitorEnvironment()) {
      this.$postMessage.openFileDownload({
        isPatient: this.userInfo.isPatient,
        isRelative: this.userInfo.isPatientRelative,
        type: 'document',
        patientId: this.patientId,
        fileId: documentId,
        fileName: file.fileName || ''
      })
      return
    }
    const res = await this.$api.document.fetchFile({
      patientId: this.patientId,
      documentId
    })
    const url = window.URL.createObjectURL(res)
    const a = document.createElement('a')
    a.style.opacity = '0'
    document.body.appendChild(a)
    a.download = file.fileName || ''
    a.href = url
    a.click()
    a.remove()
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  }

  async fetchFiles() {
    try {
      const res = await this.$api.document.fetch({
        patientId: this.patientId,
        page: this.pageNation
      })
      if (res.next) {
        this.perPage = res.results.length
      } else if (res.previous) {
        const res2 = await this.$api.document.fetch({
          patientId: this.patientId,
          page: this.pagePrev
        })
        this.perPage = res2.results.length
      } else {
        this.perPage = res.results.length
      }

      this.maxfiles = res.count
      this.files = res.results.map(file => {
        return Object.assign({}, file, {
          title: file.title || '',
          description: file.description || ''
        })
      })
    } catch (e) {
      if (e.message === 'Not Found' && this.pageNation > 1) {
        // 存在しないページネーションを呼び出した場合
        this.$router.replace({ path: this.$route.path })
      }
    }
  }

  async deleteFile(id: number) {
    this.showDeleteConfirmModal = true
    const resust = await new Promise<DeleteConfirmResults>(resolve =>
      this.events.once(EventTypes.CONFIRM_DELETE, resolve)
    )
    this.showDeleteConfirmModal = false
    if (resust === DeleteConfirmResults.CANCEL) {
      return
    }

    await this.$api.document.delete({
      patientId: this.patientId,
      documentId: id
    })
    await this.fetchFiles()
  }

  created() {
    this.fetchPatient()
    this.fetchFiles()
  }

  range(n: number) {
    return Array.from({ length: n }, (v, k) => k + 1)
  }

  getSenderName(file: DocumentFile) {
    return file.worker
      ? `${file.worker.lastName}${file.worker.firstName}`
      : '患者'
  }
}
